export const excludedFields = [
  'allDay',
  'audience',
  'cle',
  'clientEventOrCelebration',
  'created_by',
  'description',
  'eventTypeOther',
  'firmInitiatives',
  'isRecurring',
  'mlSpeaker',
  'isOutsideSpeaker',
  'outsideSpeakers',
  'recurrence',
  'sponsoringOrganization',
  'hostingGroupOther',
  'updated_by',
  'updated_by_user',
  'uuid',
];

export const exportFieldOrder: string[] = [
  'title',
  'start',
  'end',
  'timezone',
  'hostingType',
  'eventType',
  'created_by_user',
  'eventContact',
  'sponsoringAttorney',
  'practiceGroups',
  'industries',
  'departments',
  'isLocationExternal',
  'officeLocation',
  'externalLocation',
  'inviteOnly',
  'id',
];
